import React, { useState } from 'react'
import Button from '../../atoms/button/button'
import Menu from '../../atoms/menu/menu'
import ModalLogin from '../modal-login/modal-login'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import './academy-content.scss'

const AcademyContent = () => {
  const {
    producto1: { childImageSharp: producto1 },
    producto2: { childImageSharp: producto2 },
    producto3: { childImageSharp: producto3 },
    producto4: { childImageSharp: producto4 },
    producto5: { childImageSharp: producto5 },
    articulo1: { childImageSharp: articulo1 },
    articulo2: { childImageSharp: articulo2 },
    articulo3: { childImageSharp: articulo3 },
    banner: { childImageSharp: banner },
    bgProduct: { childImageSharp: bgProduct },
    bgProductMobile: { childImageSharp: bgProductMobile },
    bannerMobile: { childImageSharp: bannerMobile },
  } = useStaticQuery(graphql`
    {
      bgProduct: file(name: { eq: "Fondo-morado-horizontal" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      bgProductMobile: file(name: { eq: "Fondo-morado-vertical" }) {
        childImageSharp {
          gatsbyImageData
        }
      }

      producto1: file(name: { eq: "producto-buenas-noches-natural" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      producto2: file(
        name: { eq: "producto-buenas-noches-invisible-rapisec" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      producto3: file(name: { eq: "producto-buenas-noches-organico" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      producto4: file(
        name: { eq: "producto-buenas-noches-360-maxima-proteccion" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      producto5: file(name: { eq: "producto-buenas-noches-extra-proteccion" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      articulo1: file(name: { eq: "tips-para-dormir-bien" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      articulo2: file(
        name: { eq: "Como-evitar-y-aliviar-el-colico-menstrual-desktop" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      articulo3: file(
        name: { eq: "habitos-para-tener-mejores-mananas-desktop__1_" }
      ) {
        childImageSharp {
          gatsbyImageData
        }
      }
      banner: file(name: { eq: "Inscribete-banner" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      bannerMobile: file(name: { eq: "Inscribete-banner-mobile" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  const products = [
    {
      title: 'Nosotras Natural Buenas Noches',
      description: '8cm más larga que una toalla normal y más ancha atrás.',
      redirect:
        '/productos/durante-tu-periodo/toallas-higienicas/toallas-nosotras-natural-buenas-noches',
      image: producto1,
    },
    {
      title: 'Nosotras Buenas Noches Rapisec',
      description: 'Siéntete cómoda, seca y segura mientras duermes ',
      redirect:
        '/productos/durante-tu-periodo/toallas-higienicas/toallas-nosotras-buenas-noches-invisible-rapisec',
      image: producto2,
    },
    {
      title: 'Nosotras Buenas Noches Algodón 100%',
      description: 'Centro absorbente con fibras 100% orgánicas y naturales',
      redirect:
        '/productos/durante-tu-periodo/toallas-higienicas/toallas-nosotras-buenas-noches-100-organico',
      image: producto3,
    },
    {
      title: 'Nosotras Buenas Noches Máxima Protección',
      description: 'Para flujo súper abundante máxima protección',
      redirect:
        '/productos/durante-tu-periodo/toallas-higienicas/toallas-buenas-noches-maxima-proteccion/',
      image: producto4,
    },
    {
      title: 'Nosotras Buenas Noches Extra Protección',
      description: 'Ideales para flujo abundante. ¡Úsalas de día y de noche!',
      redirect:
        '/productos/durante-tu-periodo/toallas-higienicas/toallas-nosotras-extraproteccion',
      image: producto5,
    },
  ]

  const articles = [
    {
      title: '7 tips para dormir bien',
      description:
        'Una buena noche significa un buen día. Sigue estos 7 tips para dormir bien y… ',
      image: articulo1,
      redirection: '/magazin/nuestro-mundo/7-tips-para-dormir-bien/',
    },
    {
      title: '¿Cómo evitar y aliviar el cólico menstrual?',
      description:
        '¿Sufres de cólicos menstruales? ¡Sabemos por lo que estás pasando! Te contamos…',
      image: articulo2,
      redirection:
        '/magazin/nuestro-mundo/como-evitar-y-aliviar-el-colico-menstrual/',
    },
    {
      title: 'Hábitos para tener mañanas más productivas',
      description:
        'Organízate y aprovecha tu tiempo, ¡y ten mañanas muy productivas…',
      image: articulo3,
      redirection:
        '/magazin/nuestro-mundo/habitos-para-tener-mananas-productivas-nosotras-colombia/',
    },
  ]

  const [isModalOpen, setIsModalOpen] = useState()
  return (
    <>
      <Menu />
      <div className="f-academy-ambassador">
        <div className="f-academy-ambassador-header">
          <div className="f-academy-ambassador-wrapper">
            <h1 className="f-academy-ambassador__title">
              <b>NOSOTRAS</b> <span>BUENAS NOCHES</span>
            </h1>
            <Button
              color="blue"
              onClick={() => {
                window.open('https://www.nosotrasonline.com.co/entre-nosotras/cuidado-femenino/mitos-y-verdades-de-la-menstruacion-durante-la-noche-nosotras-colombia/', '_blank');
              }}

            >
              Conoce más
            </Button>
          </div>

          <div className="f-academy-ambassador__video">
            <iframe
              frameborder="0"
              allowfullscreen
              src="https://www.youtube.com/embed/HZaLHtYVlWQ?controls=1"
            />
          </div>
        </div>

        <div className="f-products">
          <GatsbyImage
            className="f-bg-product"
            image={withArtDirection(getImage(bgProduct), [
              {
                media: '(max-width: 900px)',
                image: getImage(bgProductMobile),
              },
            ])}
          />
          <div className="f-products-content">
            {products.map(product => (
              <div className="f-product">
                <GatsbyImage
                  className="f-product__img"
                  image={getImage(product.image)}
                />
                <h1 className="f-product__title">{product.title}</h1>
                <p className="f-product__description">{product.description}</p>
                <Button
                  color="blue"
                  onClick={() => {
                    window.open(product.redirect, '_blank')
                  }}
                >
                  Conoce más
                </Button>
              </div>
            ))}
          </div>
        </div>
        <div className="f-articles">
          <h1 className="f-academy-ambassador__title">
            <b> APRENDE </b> MÁS CON <span>ESTOS ARTÍCULOS</span>
          </h1>
          <div className="f-articles-content">
            {articles.map(article => (
              <div className="f-article">
                <GatsbyImage
                  objectFit="cover"
                  className="f-article__img"
                  image={getImage(article.image)}
                />
                <div className="f-article-content">
                  <h1 className="f-article__title">{article.title}</h1>
                  <p className="f-article__description">
                    {article.description}
                  </p>
                  <a
                    className="f-article__link"
                    href={article.redirection}
                    target="_blank"
                  >
                    Leer más
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
        <GatsbyImage
          onClick={() => {
            setIsModalOpen(true)
          }}
          objectFit="contain"
          className="f-academy-banner"
          image={withArtDirection(getImage(banner), [
            {
              media: '(max-width: 900px)',
              image: getImage(bannerMobile),
            },
          ])}
        />
      </div>
      {isModalOpen && (
        <ModalLogin
          onClose={() => {
            setIsModalOpen(false)
          }}
        />
      )}
    </>
  )
}

export default AcademyContent
